import { IRoutes, IUnauthorizedRoutes } from "../interfaces/routes";

/**
 * Blankettens URL. Hed indtil ADV-295 "/selskabsblanketten"; navnet er skiftet til
 * Virksomhedsblanketten, og stien fulgte med, fordi adresselinjen også er brugersynlig.
 *
 * LEGACY-stien skal blive ved at virke: advokater har haft blanketten i en måned og kan have
 * bogmærket den. Den redirecter til den kanoniske sti, og den står stadig som regel i
 * DELEGATED_ROUTE_RULES — uden det ville canAccessDelegatedPath afvise en fuldmægtig på det
 * gamle bogmærke, FØR redirectet kunne køre (den returnerer false når ingen regel matcher).
 */
export const VIRKSOMHEDSBLANKET_PATH = "/virksomhedsblanketten";
export const VIRKSOMHEDSBLANKET_LEGACY_PATH = "/selskabsblanketten";

export const ROUTES: IRoutes = {
  notFoundGlobal: { id: "404Global", visningsNavn: "404" },
  notFoundHome: { id: "404Home", visningsNavn: "404" },
  homeIndex: {
    id: "home-index",
    visningsNavn: "Indberetning",
  },
  homeWelcome: { id: "home-welcome", visningsNavn: "" },
  tilsynForm: { id: "home-tilsyn", visningsNavn: "Tilsynserklæring" },
  klientkonto: {
    id: "home-klientkonto",
    visningsNavn: "Klientkontoerklæring",
  },
  klientkontoTilsvar: {
    id: "home-klientkonto-tilsvar",
    visningsNavn: "Formular I - Tilsvar",
  },
  klientkontoIntetTilsvar: {
    id: "home-klientkonto-intet-tilsvar",
    visningsNavn: "Formular II - Intet tilsvar",
  },
  sluterklaering: {
    id: "home-sluterklaering",
    visningsNavn: "Sluterklæring",
  },
  sluterklaeringTilsvar: {
    id: "home-sluterklaering-tilsvar",
    visningsNavn: "Formular I - Tilsvar",
  },
  sluterklaeringIntetTilsvar: {
    id: "home-sluterklaering-intet-tilsvar",
    visningsNavn: "Formular II - Intet tilsvar",
  },
  efteruddannelse: {
    id: "home-efteruddannelse",
    visningsNavn: "Efteruddannelse",
  },
  efteruddannelseIndberet: {
    id: "home-efteruddannelse-indberet",
    visningsNavn: "Indberet",
  },
  selskabsblanketten: {
    id: "home-selskabsblanketten",
    visningsNavn: "Virksomhedsblanketten",
  },
  loginCompanyNotFound: {
    id: "home-company-not-found",
    visningsNavn: "Firma Ikke fundet",
  },
  loginInvalidToken: {
    id: "home-invalid-token",
    visningsNavn: "Ugyldig token",
  },
  logoutRedirect: {
    id: "home-logout-done",
    visningsNavn: "Logget ud",
  },
  midIdFailureRedicret: {
    id: "home-mit-id-fail",
    visningsNavn: "MitID Fejl",
  },
  userNotFound: {
    id: "home-user-not-found",
    visningsNavn: "Brugeren findes ikke",
  },
  unauth: {
    id: "home-unauth",
    visningsNavn: "Uautoriseret",
  },
  signeringDone: {
    id: "home-signering-done",
    visningsNavn: "Signering",
  },
  account: { id: "account", visningsNavn: "Dine oplysninger" },
  idkort: { id: "idkort", visningsNavn: "ID-kort" },
  delegationAccept: {
    id: "delegation-accept",
    visningsNavn: "Fuldmagt login",
  },
  linkToken: {
    id: "link-token",
    visningsNavn: "Klientkontoerklæring",
  },
  tilsynsLinkToken: {
    id: "tilsyn-link-token",
    visningsNavn: "Tilsynerklæring",
  },
  linkUgyldig: {
    id: "link-ugyldig",
    visningsNavn: "Ugyldig",
  },
  design: {
    id: "design",
    visningsNavn: "Design",
  },
  kkeDesign: {
    id: "design-kke",
    visningsNavn: "Klientkontoerklæring",
  },
  teDesign: {
    id: "design-te",
    visningsNavn: "Tilsynserklæring",
  },
};

export const UNAUTHORIZED_ROUTES: IUnauthorizedRoutes = {
  signeringFailure: {
    id: "signering-failure",
    visningsNavn: "Signering fejl",
    pathName: "/Home/SigneringFailure",
  },
  mitIdLoginFailure: {
    id: "mit-id-login-failure",
    visningsNavn: "MitId login fejl",
    pathName: "/Home/MitIdLoginFailure",
  },
};
